<template>
  <span class="rounded-full pb-1 pt-1 pl-2 pr-2 border-2" :class="typeClass">
    <el-tooltip v-model="tooltipVisible" manual :open-delay="200">
      <div slot="content">
        <div class="max-w-sm max-h-500p overflow-auto text-sm dark:text-secondary-200 block">
          <div>
            <ul v-if="group.NombreGrupo">
              <li>{{ `Obligatorio: ${group.Obligatorio ? $t('app.yes') : $t('app.no')}` }}</li>
                <li>{{ `Orden: ${group.Orden}` }}</li>
            </ul>
            <ul v-else>
              <li>{{ group.Propietario ? $t('groups.owner') : '' }}</li>
                <li>{{ `${$t('configurations.tipo_grupo')}: ${tipoGrupo}` }}</li>
            </ul>
          </div>
        </div>
      </div>
      <span
          @keydown.esc="tooltipVisible = false"
          @mouseenter="tooltipVisible = true"
          @mouseleave="tooltipVisible = false"
          @focus="tooltipVisible = true"
          @blur="tooltipVisible = false">
        <base-icon v-if="group.Propietario" name="key" size="xs"/>
        <span>{{ group.Nombre || group.NombreGrupo }}</span>
      </span>
    </el-tooltip>  
  </span>
</template>

<script>
import { i18n } from '@/i18n'

export default {
  name: 'rounded-group',
  props: {
    group: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      tooltipVisible: false
    }
  },
  computed: {
    idTipo: function () {
      return this.group.idTipo
    },
    typeClass: function () {
      if (this.idTipo) {
        switch (this.idTipo) {
          case 1:
            return 'bg-primary-800 dark:bg-darkblue text-white group-pool'
          case 2:
            return 'bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 group-border'
          case 3:
            return 'bg-secondary-600 dark:bg-secondary-600 text-white group-reparto'
        }
      } 
      return 'bg-primary-50 dark:bg-darkblue text-primary-800 dark:text-primary-600 group-border'
    },
    tipoGrupo: function () {
      const tiposGrupo = this.$store.getters['config/TIPOS_GRUPO']
      const tipo = tiposGrupo.find(x => x.id === this.idTipo)
      if (tipo?.name) {
        return tipo.name
      }
      console.warn(i18n.t('feedback.warning.bad_enum_value_warn', { field: 'TipoGrupo', value: this.idTipo }))
      return this.idTipo
    },
  },
}
</script>

<style>
.pb-0\.5 {
  padding-bottom: 0.125rem /* 2px */;
}
.pt-0\.5 {
  padding-top: 0.125rem /* 2px */;
}
</style>
